/* Metry theme — global (header, cart, animations) */
  class MtPromoBar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-promo-slide]'));
      this.index = 0;
      this.timerId = null;
      this.tickId = null;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 5000);
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.slides.length) return;

      this.index = this.slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      if (this.index < 0) this.index = 0;

      var prev = this.querySelector('[data-promo-prev]');
      var next = this.querySelector('[data-promo-next]');
      if (prev) prev.addEventListener('click', this.prev.bind(this));
      if (next) next.addEventListener('click', this.next.bind(this));

      this.addEventListener('mouseenter', this.pause.bind(this));
      this.addEventListener('mouseleave', this.resume.bind(this));
      this.addEventListener('focusin', this.pause.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));

      this.syncNav();
      this.updateCountdowns();
      this.tickId = setInterval(this.updateCountdowns.bind(this), 1000);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.pause();
      if (this.tickId) clearInterval(this.tickId);
      if (this._leaveTimer) {
        clearTimeout(this._leaveTimer);
        this._leaveTimer = null;
      }
    }

    onFocusOut(e) {
      if (!this.contains(e.relatedTarget)) this.resume();
    }

    isCountdownPending(slide) {
      var raw = slide.getAttribute('data-start');
      if (!raw || !String(raw).trim()) return false;
      var start = this.parseEnd(raw);
      if (start == null) return false;
      return Date.now() < start;
    }

    isCountdownExpired(slide) {
      var raw = slide.getAttribute('data-end');
      if (!raw || !String(raw).trim()) return false;
      var end = this.parseEnd(raw);
      if (end == null) return false;
      return end - Date.now() <= 0;
    }

    isCountdownLive(slide) {
      return !this.isCountdownPending(slide) && !this.isCountdownExpired(slide);
    }

    syncNav() {
      var showNav = this.slides.length > 1;
      var prev = this.querySelector('[data-promo-prev]');
      var next = this.querySelector('[data-promo-next]');
      if (prev) prev.hidden = !showNav;
      if (next) next.hidden = !showNav;
    }

    notifyPromoBarOffset() {
      var header = document.querySelector('mt-header');
      if (header && typeof header.updatePromoBarOffset === 'function') {
        header.updatePromoBarOffset();
        requestAnimationFrame(function () {
          header.updatePromoBarOffset();
        });
      }
    }

    go(i) {
      if (!this.slides.length) return;
      var len = this.slides.length;
      var next = ((i % len) + len) % len;
      if (next === this.index) return;

      var prevSlide = this.slides[this.index];
      var nextSlide = this.slides[next];
      this.index = next;

      if (this.reduceMotion) {
        this.slides.forEach(function (slide, n) {
          var active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.classList.remove('is-leaving');
          if (active) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        }, this);
      } else {
        if (this._leaveTimer) {
          clearTimeout(this._leaveTimer);
          this._leaveTimer = null;
        }
        this.slides.forEach(function (slide) {
          if (slide === prevSlide || slide === nextSlide) return;
          slide.classList.remove('is-leaving', 'is-active');
          slide.setAttribute('aria-hidden', 'true');
        });
        prevSlide.classList.add('is-leaving');
        prevSlide.classList.remove('is-active');
        prevSlide.setAttribute('aria-hidden', 'true');
        nextSlide.classList.remove('is-leaving');
        nextSlide.classList.add('is-active');
        nextSlide.removeAttribute('aria-hidden');
        this._leaveTimer = setTimeout(function () {
          prevSlide.classList.remove('is-leaving');
          this._leaveTimer = null;
        }.bind(this), 650);
      }

      this.updateCountdownDigits();
    }

    next() {
      this.go(this.index + 1);
      this.restartAutoplay();
    }

    prev() {
      this.go(this.index - 1);
      this.restartAutoplay();
    }

    startAutoplay() {
      this.pause();
      if (!this.autoplay || this.reduceMotion) return;
      this.timerId = setInterval(this.next.bind(this), this.interval);
    }

    restartAutoplay() {
      if (!this.autoplay || this.reduceMotion) return;
      this.startAutoplay();
    }

    pause() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    }

    resume() {
      if (!this.slides.length) return;
      this.startAutoplay();
    }

    pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    parseEnd(raw) {
      if (!raw) return null;
      var normalized = String(raw).trim().replace(' ', 'T');
      var t = Date.parse(normalized);
      if (Number.isNaN(t)) t = Date.parse(normalized + 'Z');
      return Number.isNaN(t) ? null : t;
    }

    formatRemaining(ms) {
      if (ms <= 0) return '00&nbsp;:&nbsp;00&nbsp;:&nbsp;00&nbsp;:&nbsp;00';
      var total = Math.floor(ms / 1000);
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;
      return this.pad(days) + '&nbsp;:&nbsp;' + this.pad(hours) + '&nbsp;:&nbsp;' + this.pad(mins) + '&nbsp;:&nbsp;' + this.pad(secs);
    }

    updateCountdownDigits() {
      var now = Date.now();
      this.slides.forEach(function (slide) {
        var timer = slide.querySelector('[data-promo-timer]');
        var el = slide.querySelector('[data-promo-countdown]');
        if (!el) {
          if (timer) timer.hidden = true;
          return;
        }

        var live = this.isCountdownLive(slide);
        if (timer) timer.hidden = !live;
        if (!live) return;

        var end = this.parseEnd(slide.getAttribute('data-end'));
        if (end == null) {
          el.innerHTML = '--&nbsp;:&nbsp;--&nbsp;:&nbsp;--&nbsp;:&nbsp;--';
          return;
        }
        el.innerHTML = this.formatRemaining(end - now);
      }, this);
    }

    updateCountdowns() {
      this.updateCountdownDigits();
    }
  }

  if (!customElements.get('mt-promo-bar')) customElements.define('mt-promo-bar', MtPromoBar);
  class CartCount extends HTMLElement {
    connectedCallback() {
      this._on = () => this.refresh();
      document.addEventListener('cart:updated', this._on);
      this.updateCount(parseInt(this.textContent, 10) || 0);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._on);
    }
    updateCount(count) {
      var n = Number.isFinite(count) ? count : 0;
      this.textContent = n;
      this.hidden = n === 0;
    }
    async refresh() {
      try {
        const c = await (await fetch('/cart.js')).json();
        this.updateCount(c.item_count);
      } catch (e) {}
    }
  }
  if (!customElements.get('cart-count')) customElements.define('cart-count', CartCount);

  class MtHeader extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mega = this.querySelector('[data-mega]');
      this.triggers = Array.from(this.querySelectorAll('[data-mega-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel-id]'));
      this.burger = this.querySelector('[data-burger]');
      this.barClose = this.querySelector('[data-drawer-close-bar]');
      this.drawer = document.querySelector('[data-drawer]');
      this.overlay = document.querySelector('[data-overlay]');
      this.closeBtn = this.barClose;
      this.closeTimer = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.triggers.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const id = btn.getAttribute('data-panel');
          const open = btn.getAttribute('aria-expanded') === 'true';
          if (open) this.closeMega();
          else this.openMega(id);
        });
        btn.addEventListener('mouseenter', () => this.openMega(btn.getAttribute('data-panel')));
      });

      this.addEventListener('mouseleave', () => this.scheduleClose());
      this.addEventListener('mouseenter', () => this.cancelClose());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeMega();
          this.toggleDrawer(false);
        }
      });

      if (this.burger && this.drawer) {
        this.burger.addEventListener('click', () => this.toggleDrawer());
        if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.toggleDrawer(false));
        if (this.overlay) this.overlay.addEventListener('click', () => this.toggleDrawer(false));
        this.drawer.addEventListener('click', (e) => {
          const openMega = e.target.closest('[data-drawer-mega-open]');
          if (openMega) {
            e.preventDefault();
            this.openDrawerMega(openMega.getAttribute('data-drawer-mega-open'));
            return;
          }
          if (e.target.closest('[data-drawer-back]')) {
            e.preventDefault();
            this.closeDrawerMega();
            return;
          }
          if (e.target.closest('a.mt-header__card, a.mt-header__drawer-link, a.mt-header__drawer-cta')) {
            this.toggleDrawer(false);
          }
        });
      }

      this.querySelectorAll('[data-locale-select]').forEach((sel) => {
        sel.addEventListener('change', () => sel.form && sel.form.submit());
      });

      this._markets = Array.from(document.querySelectorAll('[data-markets]'));
      if (this._markets.length) {
        this._onDocClick = (e) => {
          this._markets.forEach((details) => {
            if (details.open && !details.contains(e.target)) details.open = false;
          });
        };
        document.addEventListener('click', this._onDocClick);
      }

      if (this.classList.contains('mt-header--home')) {
        this._onScroll = () => {
          if (this.classList.contains('is-mega-open')) {
            this.updatePromoBarOffset();
            return;
          }
          if (this.classList.contains('is-drawer-open')) return;
          this.classList.toggle('is-scrolled', window.scrollY > 40);
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();
      }

      this.updatePromoBarOffset();
      const promoSection = document.querySelector('.section-mt-promo-bar');
      const promo = document.querySelector('mt-promo-bar');
      if (typeof ResizeObserver !== 'undefined') {
        this._promoRo = new ResizeObserver(() => this.updatePromoBarOffset());
        if (promoSection) this._promoRo.observe(promoSection);
        if (promo) this._promoRo.observe(promo);
      }

      this.initMegaProductTabs();
      this.initMegaDrawerAccordion();
    }

    initMegaDrawerAccordion() {
      if (!this.drawer) return;
      this.drawer.querySelectorAll('[data-mega-drawer-accordion]').forEach((root) => {
        if (root.dataset.megaAccReady === 'true') return;
        root.dataset.megaAccReady = 'true';

        const triggers = Array.from(root.querySelectorAll('[data-mega-tab-trigger]'));
        const panels = Array.from(root.querySelectorAll('[data-mega-tab-panel]'));
        const activeBtn = root.querySelector('[data-mega-active-tab]');
        const activeLabel = root.querySelector('[data-mega-active-label]');
        const cardsWrap = root.querySelector('[data-mega-cards-wrap]');
        if (!triggers.length || !panels.length) return;

        let currentId = triggers[0].getAttribute('data-mega-tab-trigger');
        let expanded = true;

        const setExpanded = (on) => {
          expanded = on;
          if (cardsWrap) cardsWrap.hidden = !on;
          if (activeBtn) activeBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
          root.classList.toggle('is-cards-collapsed', !on);
        };

        const showTab = (id) => {
          currentId = id;
          const activeTrigger = triggers.find((t) => t.getAttribute('data-mega-tab-trigger') === id);
          triggers.forEach((trigger) => {
            trigger.classList.toggle('is-active', trigger.getAttribute('data-mega-tab-trigger') === id);
          });
          panels.forEach((panel) => {
            const on = panel.getAttribute('data-mega-tab-panel') === id;
            if (on) panel.removeAttribute('hidden');
            else panel.setAttribute('hidden', '');
          });
          const label = activeTrigger ? activeTrigger.textContent.trim() : '';
          if (activeLabel) activeLabel.textContent = label;
          else if (activeBtn && label) activeBtn.childNodes[0].textContent = label;
        };

        if (activeBtn) {
          activeBtn.addEventListener('click', () => setExpanded(!expanded));
        }

        triggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const id = trigger.getAttribute('data-mega-tab-trigger');
            if (id === currentId) setExpanded(!expanded);
            else {
              showTab(id);
              setExpanded(true);
            }
          });
        });

        root._resetMegaTab = () => {
          showTab(triggers[0].getAttribute('data-mega-tab-trigger'));
          setExpanded(true);
        };
        root._resetMegaTab();
      });
    }

    initMegaProductTabs() {
      const roots = [
        ...this.querySelectorAll('[data-mega-products]'),
        ...(this.drawer ? this.drawer.querySelectorAll('[data-mega-products]') : []),
      ];
      roots.forEach((root) => {
        if (root.dataset.megaTabsReady === 'true') return;
        root.dataset.megaTabsReady = 'true';

        const triggers = Array.from(root.querySelectorAll('[data-mega-tab-trigger]'));
        const panels = Array.from(root.querySelectorAll('[data-mega-tab-panel]'));
        if (triggers.length < 2 || panels.length < 2) return;

        const sideList = root.querySelector('.mt-header__side-list--tabbed');
        const sidePill = sideList && sideList.querySelector('.mt-header__side-pill');

        const getSidePillOffset = (trigger) => {
          const item = trigger.closest('li');
          if (!item || !sideList.contains(item)) return trigger.offsetTop;
          return item.offsetTop + trigger.offsetTop;
        };

        const updateSidePill = (activeTrigger) => {
          if (!sidePill || !activeTrigger || !sideList) return;
          const move = () => {
            sidePill.style.height = activeTrigger.offsetHeight + 'px';
            sidePill.style.transform = 'translateY(' + getSidePillOffset(activeTrigger) + 'px)';
          };
          move();
          requestAnimationFrame(move);
        };

        const activate = (id) => {
          const activeTrigger = triggers.find((trigger) => trigger.getAttribute('data-mega-tab-trigger') === id);
          triggers.forEach((trigger) => {
            const on = trigger.getAttribute('data-mega-tab-trigger') === id;
            trigger.classList.toggle('is-active', on);
            if (trigger.hasAttribute('aria-selected')) {
              trigger.setAttribute('aria-selected', on ? 'true' : 'false');
            }
          });
          panels.forEach((panel) => {
            const on = panel.getAttribute('data-mega-tab-panel') === id;
            if (on) panel.removeAttribute('hidden');
            else panel.setAttribute('hidden', '');
          });
          const activeLabel = root.querySelector('[data-mega-active-tab]');
          if (activeLabel && activeTrigger) activeLabel.textContent = activeTrigger.textContent.trim();
          updateSidePill(activeTrigger);
        };

        triggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            activate(trigger.getAttribute('data-mega-tab-trigger'));
          });
        });

        root._updateSidePill = () => {
          const active = triggers.find((trigger) => trigger.classList.contains('is-active')) || triggers[0];
          updateSidePill(active);
        };

        root._resetMegaTab = () => activate(triggers[0].getAttribute('data-mega-tab-trigger'));
        root._resetMegaTab();

        if (sideList && typeof ResizeObserver !== 'undefined') {
          root._sidePillRo = new ResizeObserver(() => root._updateSidePill());
          root._sidePillRo.observe(sideList);
        }
      });
    }

    disconnectedCallback() {
      if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._promoRo) this._promoRo.disconnect();
      if (this._megaCloseTimer) clearTimeout(this._megaCloseTimer);
    }

    closeMarkets() {
      if (!this._markets) return;
      this._markets.forEach((details) => { details.open = false; });
    }

    updatePromoBarOffset() {
      const promo = document.querySelector('mt-promo-bar');
      const section = document.querySelector('.section-mt-promo-bar');

      if (!promo || !section || section.hidden) {
        document.documentElement.style.setProperty('--mt-promo-bar-height', '0px');
        document.documentElement.style.setProperty('--mt-promo-bar-offset', '0px');
        document.documentElement.classList.remove('is-mega-promo-pinned');
        return;
      }

      const rect = promo.getBoundingClientRect();
      const height = Math.ceil(rect.height);
      document.documentElement.style.setProperty('--mt-promo-bar-height', height + 'px');

      const megaOpen = this.classList.contains('is-mega-open');
      const pinPromo = megaOpen && rect.top >= -1;
      document.documentElement.classList.toggle('is-mega-promo-pinned', pinPromo);

      let offset = 0;
      if (megaOpen && (pinPromo || rect.top >= 0)) {
        offset = pinPromo ? height : Math.ceil(rect.bottom);
      }
      document.documentElement.style.setProperty('--mt-promo-bar-offset', offset + 'px');
    }

    openMega(id) {
      this.closeMarkets();
      this.cancelClose();
      if (this._megaCloseTimer) {
        clearTimeout(this._megaCloseTimer);
        this._megaCloseTimer = null;
      }
      if (!this.mega) return;
      this.mega.removeAttribute('hidden');
      this.panels.forEach((panel) => {
        const match = panel.getAttribute('data-panel-id') === id;
        if (match) {
          panel.removeAttribute('hidden');
          panel.classList.add('is-mega-active');
          if (!this.reduceMotion) {
            panel.classList.remove('is-mega-animate');
            void panel.offsetWidth;
            panel.classList.add('is-mega-animate');
          }
        } else {
          panel.setAttribute('hidden', '');
          panel.classList.remove('is-mega-active', 'is-mega-animate');
        }
      });
      this.triggers.forEach((btn) => {
        const on = btn.getAttribute('data-panel') === id;
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      this.classList.add('is-mega-open');
      if (this.classList.contains('mt-header--home')) {
        this.classList.remove('is-scrolled');
      }
      this.updatePromoBarOffset();
      requestAnimationFrame(() => this.updatePromoBarOffset());
      const activePanel = this.panels.find((panel) => panel.getAttribute('data-panel-id') === id);
      const megaProducts = activePanel && activePanel.querySelector('[data-mega-products]');
      if (megaProducts && megaProducts._resetMegaTab) megaProducts._resetMegaTab();
      if (megaProducts && megaProducts._updateSidePill) {
        requestAnimationFrame(() => megaProducts._updateSidePill());
        const panelAnimateMs = this.reduceMotion ? 0 : 420;
        if (panelAnimateMs) {
          setTimeout(() => megaProducts._updateSidePill(), panelAnimateMs);
        }
      }
    }

    closeMega() {
      this.cancelClose();
      if (!this.classList.contains('is-mega-open')) return;
      this.classList.remove('is-mega-open');
      this.updatePromoBarOffset();
      this.triggers.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

      const finishClose = () => {
        if (this.classList.contains('is-mega-open')) return;
        this.panels.forEach((panel) => {
          panel.setAttribute('hidden', '');
          panel.classList.remove('is-mega-active', 'is-mega-animate');
        });
        if (this.mega) this.mega.setAttribute('hidden', '');
        if (this.classList.contains('mt-header--home') && this._onScroll) this._onScroll();
      };

      if (this.reduceMotion) {
        finishClose();
        return;
      }

      if (this._megaCloseTimer) clearTimeout(this._megaCloseTimer);
      this._megaCloseTimer = setTimeout(finishClose, 320);
    }

    scheduleClose() {
      this.cancelClose();
      this.closeTimer = setTimeout(() => this.closeMega(), 160);
    }

    cancelClose() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }

    toggleDrawer(force) {
      if (!this.drawer || !this.overlay) return;
      const willOpen = force ?? this.drawer.hasAttribute('hidden');
      if (willOpen) this.closeMarkets();
      [this.drawer, this.overlay].forEach((el) => {
        if (!el) return;
        if (willOpen) {
          el.removeAttribute('hidden');
          el.classList.add('is-open');
        } else {
          el.classList.remove('is-open');
          setTimeout(() => el.setAttribute('hidden', ''), this.reduceMotion ? 0 : 300);
        }
      });
      if (this.burger) {
        this.burger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        this.burger.hidden = willOpen;
      }
      if (this.barClose) this.barClose.hidden = !willOpen;
      document.body.style.overflow = willOpen ? 'hidden' : '';
      this.classList.toggle('is-drawer-open', willOpen);
      if (willOpen) this.closeMega();
      else {
        this.closeDrawerMega();
        if (this.classList.contains('mt-header--home') && this._onScroll) this._onScroll();
      }
    }

    openDrawerMega(id) {
      if (!this.drawer) return;
      const main = this.drawer.querySelector('[data-drawer-main]');
      const sub = this.drawer.querySelector(`[data-drawer-sub="${id}"]`);
      if (!sub) return;
      if (main) main.setAttribute('hidden', '');
      sub.removeAttribute('hidden');
      const megaProducts = sub.querySelector('[data-mega-drawer-accordion]') || sub.querySelector('[data-mega-products]');
      if (megaProducts && megaProducts._resetMegaTab) megaProducts._resetMegaTab();
    }

    closeDrawerMega() {
      if (!this.drawer) return;
      this.drawer.querySelectorAll('[data-drawer-sub]').forEach((sub) => sub.setAttribute('hidden', ''));
      const main = this.drawer.querySelector('[data-drawer-main]');
      if (main) main.removeAttribute('hidden');
    }
  }

  if (!customElements.get('mt-header')) customElements.define('mt-header', MtHeader);
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cd-close]')) { e.preventDefault(); this.close(); return; }
        const b = e.target.closest('[data-change]');
        if (b) { this.change(b.closest('.cditem').dataset.key, parseInt(b.dataset.change, 10)); return; }
        if (e.target.closest('[data-cd-apply]')) { e.preventDefault(); this.applyDiscount(); return; }
        if (e.target.closest('[data-cd-remove-discount]')) { e.preventDefault(); this.removeDiscount(); return; }
      });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-input]')) this.change(e.target.closest('.cditem').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
        if (e.target.matches('[data-cd-note]')) this.updateNote(e.target.value);
      });
      // open when an item is added to cart
      document.addEventListener('cart:updated', (e) => {
        this.refresh();
        const source = e.detail && e.detail.source;
        if (source === 'rec-product') {
          this.open();
          return;
        }
        if ((source === 'product' || source === 'sticky-bar') && !window.matchMedia('(max-width: 749px)').matches) this.open();
      });
      // intercept any cart link across the site -> open drawer instead of navigating
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href$="/cart"]');
        if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); this.refresh(); this.open(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
    }
    open() { this.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    close() { this.classList.remove('is-open'); document.body.style.overflow = ''; }
    async change(id, quantity) {
      this.classList.add('is-loading');
      try {
        if (window.MtBundleCart && typeof window.MtBundleCart.changeLine === 'function') {
          await window.MtBundleCart.changeLine(id, quantity);
        } else {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity }) });
        }
        await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer' } }));
      } catch (e) {} finally { this.classList.remove('is-loading'); }
    }
    async updateNote(note) { try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) }); } catch (e) {} }
    async applyDiscount() {
      const input = this.querySelector('[data-cd-code]');
      const code = input && input.value.trim();
      if (!code) return;
      this.classList.add('is-loading');
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Invalid discount code');
        if (input) input.value = '';
        await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer' } }));
      } catch (e) {} finally { this.classList.remove('is-loading'); }
    }
    async removeDiscount() {
      this.classList.add('is-loading');
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' }),
        });
        if (!res.ok) {
          const data = await res.json();
          throw new Error(data.description || data.message || 'Could not remove discount');
        }
        await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer' } }));
      } catch (e) {} finally { this.classList.remove('is-loading'); }
    }
    async refresh() {
      try {
        if (window.MtBundleCart && typeof window.MtBundleCart.cleanupOrphanAddons === 'function') {
          await window.MtBundleCart.cleanupOrphanAddons();
        }
        const html = await (await fetch('/?section_id=' + this.section)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (fresh) this.innerHTML = fresh.innerHTML;
      } catch (e) {}
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  // Dr Free Gift / GFG (.gfgCartPageWrapperV2): call this instead of reloading the page.
  window.refreshCart = function () {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.refresh !== 'function') return Promise.resolve();
    return drawer.refresh().then(() => {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'gfg-app' } }));
    });
  };

  class MtGeoPopup extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const visitorCountry = (this.dataset.visitorCountry || '').toUpperCase();
      const baseStorageKey = this.dataset.storageKey || 'mt_geo_popup_dismissed';
      this.storageKey = visitorCountry ? baseStorageKey + '_' + visitorCountry : baseStorageKey;
      this.bannerStorageKey = this.storageKey + '_banner_closed';
      this.targetUrl = this.dataset.targetUrl || '';
      this.guardEnabled = this.dataset.guardEnabled === 'true' && !!this.targetUrl;
      this.bannerEnabled = this.dataset.bannerEnabled === 'true' && !!this.targetUrl;
      this.bannerDelay = Math.max(0, parseInt(this.dataset.bannerDelay, 10) || 0);
      this.mode = 'initial';

      const currentCountries = (this.dataset.currentCountries || '')
        .split(',')
        .map((c) => c.trim().toUpperCase())
        .filter(Boolean);

      if (window.Shopify && window.Shopify.designMode) return;
      if (visitorCountry && currentCountries.includes(visitorCountry)) return;

      this.banner = this.querySelector('[data-geo-banner]');
      if (this.banner) {
        const firstHeaderSection = document.querySelector('.shopify-section-group-header-group');
        if (firstHeaderSection && firstHeaderSection.parentNode) {
          firstHeaderSection.parentNode.insertBefore(this.banner, firstHeaderSection);
        }
        this.banner.querySelector('[data-geo-banner-close]')?.addEventListener('click', () => {
          this.banner.setAttribute('hidden', '');
          this.writeStorage(this.bannerStorageKey);
        });
        this.banner.querySelector('[data-geo-go]')?.addEventListener('click', () => {
          this.writeStorage(this.storageKey);
        });
      }

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-geo-dismiss]')) {
          e.preventDefault();
          this.dismiss();
          return;
        }
        if (e.target.closest('[data-geo-continue]')) {
          e.preventDefault();
          this.continueBrowsing();
          return;
        }
        const toggle = e.target.closest('[data-geo-toggle-list]');
        if (toggle) {
          e.preventDefault();
          const list = this.querySelector('[data-geo-list]');
          if (!list) return;
          const open = list.hasAttribute('hidden');
          if (open) list.removeAttribute('hidden');
          else list.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });

      this.querySelectorAll('[data-geo-go]').forEach((link) => {
        link.addEventListener('click', () => this.dismiss(false));
      });

      document.addEventListener('keydown', this._onKey = (e) => {
        if (e.key === 'Escape' && !this.hasAttribute('hidden')) this.dismiss();
      });

      if (this.guardEnabled) {
        document.addEventListener('submit', this._onGuardSubmit = (e) => this.guardSubmit(e), true);
        document.addEventListener('click', this._onGuardClick = (e) => this.guardClick(e), true);
      }

      if (this.readStorage(this.storageKey)) this.scheduleBanner();
      else this.show('initial');
    }

    disconnectedCallback() {
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
      if (this._onGuardSubmit) document.removeEventListener('submit', this._onGuardSubmit, true);
      if (this._onGuardClick) document.removeEventListener('click', this._onGuardClick, true);
      if (this._bannerTimer) clearTimeout(this._bannerTimer);
    }

    readStorage(key) {
      try { return localStorage.getItem(key) === '1'; } catch (e) { return false; }
    }

    writeStorage(key) {
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }

    setCopy(mode) {
      const heading = this.querySelector('[data-geo-heading]');
      const description = this.querySelector('[data-geo-description]');
      const continueButton = this.querySelector('[data-geo-continue]');
      const continueText = this.querySelector('[data-geo-continue-text]');
      if (heading) heading.textContent = heading.dataset[mode + 'Text'] || heading.dataset.initialText || '';
      if (description) description.textContent = description.dataset[mode + 'Text'] || description.dataset.initialText || '';
      if (continueText && continueButton) {
        continueText.textContent = continueButton.dataset[mode + 'Label'] || continueButton.dataset.initialLabel || '';
      }
    }

    show(mode) {
      this.mode = mode;
      this.setCopy(mode);
      this.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      const close = this.querySelector('[data-geo-dismiss].mt-geo-popup__close');
      if (close) close.focus({ preventScroll: true });
    }

    dismiss(showBanner = true) {
      this.writeStorage(this.storageKey);
      this.pendingAction = null;
      this.setAttribute('hidden', '');
      if (!document.querySelector('cart-drawer.is-open')) {
        document.body.style.overflow = '';
      }
      if (showBanner) this.scheduleBanner();
    }

    continueBrowsing() {
      const action = this.mode === 'guard' ? this.pendingAction : null;
      this.writeStorage(this.storageKey);
      this.pendingAction = null;
      this.setAttribute('hidden', '');
      if (!document.querySelector('cart-drawer.is-open')) document.body.style.overflow = '';
      this.scheduleBanner();
      if (action) {
        this._bypassGuard = true;
        action();
        setTimeout(() => { this._bypassGuard = false; }, 0);
      }
    }

    scheduleBanner() {
      if (!this.bannerEnabled || !this.banner || this.readStorage(this.bannerStorageKey)) return;
      if (this._bannerTimer) clearTimeout(this._bannerTimer);
      this._bannerTimer = setTimeout(() => {
        if (this.banner) this.banner.removeAttribute('hidden');
      }, this.bannerDelay);
    }

    guardSubmit(e) {
      if (this._bypassGuard) return;
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const submitter = e.submitter;
      this.pendingAction = () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      };
      this.show('guard');
    }

    guardClick(e) {
      if (this._bypassGuard) return;
      const selector = [
        '[data-sticky-atc]',
        '[data-sticky-buy-now]',
        '[data-community-atc]',
        '[data-cd-rec-add]',
        '.shopify-payment-button__button',
        'shopify-accelerated-checkout'
      ].join(',');
      const target = e.composedPath().find((node) => node instanceof Element && node.matches(selector));
      if (!target || target.closest('mt-geo-popup, [data-geo-banner]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.pendingAction = () => target.click();
      this.show('guard');
    }
  }

  if (!customElements.get('mt-geo-popup')) customElements.define('mt-geo-popup', MtGeoPopup);

  function bindDirectionFill(buttons, fillSelector, desktopOnly) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var desktopMq = window.matchMedia('(min-width: 990px)');

    buttons.forEach(function (btn) {
      var fill = btn.querySelector(fillSelector);
      if (!fill || btn.disabled) return;

      var side = function (e) {
        var rect = btn.getBoundingClientRect();
        return e.clientX < rect.left + rect.width / 2 ? 'left' : 'right';
      };

      btn.addEventListener('pointerenter', function (e) {
        if (desktopOnly && !desktopMq.matches) return;
        if (reduceMotion) {
          btn.classList.add('is-fill');
          return;
        }
        fill.style.transition = 'none';
        fill.style.transformOrigin = side(e);
        void fill.offsetWidth;
        fill.style.transition = 'transform 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.transform = 'scaleX(1)';
        btn.classList.add('is-fill');
      });

      btn.addEventListener('pointerleave', function (e) {
        if (desktopOnly && !desktopMq.matches) return;
        if (reduceMotion) {
          btn.classList.remove('is-fill');
          return;
        }
        fill.style.transformOrigin = side(e);
        fill.style.transform = 'scaleX(0)';
        btn.classList.remove('is-fill');
      });
    });
  }

  (function () {
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('reveal-in');
      });
    }

    function initReveal() {
      var els = document.querySelectorAll('[data-reveal]');
      if (reduce || !('IntersectionObserver' in window)) {
        revealAll();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initImageFade() {
      document.querySelectorAll('img.lazy-fade').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
        }
      });
    }

    function start() {
      initReveal();
      initImageFade();
      bindDirectionFill(document.querySelectorAll('.mt-footer__submit'), '.mt-footer__submit-fill');
      bindDirectionFill(document.querySelectorAll('.mt-help-search__submit'), '.mt-help-search__submit-fill', true);
      bindDirectionFill(document.querySelectorAll('.mt-help-download__button'), '.mt-help-download__button-fill', true);
      bindDirectionFill(document.querySelectorAll('.mt-help-contact__button'), '.mt-help-contact__button-fill', true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
